module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('i', {
    class: {
      'weui-icon-success': _vm.success,
      'weui-icon-success-no-circle': _vm.nike,
      'weui-icon-circle': _vm.circle,
      'weui-icon-warn': _vm.warn,
      'weui-icon-download': _vm.download,
      'weui-icon-info-circle': _vm.info,
      'weui-icon-cancel': _vm.cancel,
      'weui-icon-search': _vm.search,
      'weui-loading': _vm.loading,
    },
    on: {
      "click": _vm.onItemClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6e865743!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/icon.vue
// module id = 262
// module chunks = 0